<template>
    <meta name="viewport" content="width=device-width,initial-scale=1.0" />
    <Widget title="Расчет стоимости ленточного конвейера" @resize="set_style($event)" v-if="conveyor.options">
        <WidgetPart>
            <Slider v-model="slide_index" :style="widget_style">
                <!-- расчет стоимости -->
                <Slide index="1" title="Основные параметры" :cur_index="slide_index">
                    <!-- ширина ленты -->
                    <Paragraph title="Ширина ленты, мм">
                        <select class="field short" v-model="conveyor.band_width" @change="get_price('s')" :class="{ 'required disabled': !conveyor.band_width }">
                            <option disabled value="undefined" style="display: none; color: grey">Выберите ширину ленты</option>
                            <option v-for="val in conveyor.band_widths" :value="val" :key="val">
                                {{ val }}
                            </option>
                        </select>
                    </Paragraph>

                    <!-- тип ленты -->
                    <Paragraph title="Тип ленты">
                        <div class="field_container">
                            <select class="field" v-model="conveyor.band_type" @change="get_price('s')" :class="{ 'required disabled': !conveyor.band_type }">
                                <option disabled value="undefined" style="display: none; color: grey">Выберите тип ленты</option>
                                <option v-for="val of [4, 5, 6]" :key="val" :value="val">
                                    {{ conveyor.options[val].name }}
                                </option>
                            </select>
                            <Info style="padding-right: 0px">
                                <div class="info_style_1">
                                    <div class="info_style_1_content">
                                        <div class="info_style_1_title">{{ conveyor.options[conveyor.band_type].name }}</div>
                                        <hr />
                                        <img class="info_style_1_image" :src="conveyor.options[conveyor.band_type].image" :alt="conveyor.options[conveyor.band_type].name" />
                                        <div class="info_style_1_description">{{ conveyor.options[conveyor.band_type].description }}</div>
                                    </div>
                                </div>
                            </Info>
                        </div>
                    </Paragraph>

                    <!-- длина конвейера -->
                    <Paragraph title="Длина конвейера, м" style="height: 85px">
                        <input class="field short" placeholder="Укажите длину конвейера от 3 до 30м" type="text" v-model="conveyor.length" @input="get_price('s')" @change="get_price('s')" :class="{ required: !conveyor.length || conveyor.length == '' }" />
                        <div class="error">{{ length_error_message }}</div>
                    </Paragraph>                    
                </Slide>

                <Slide index="2" title="Конструктив конвейера" :cur_index="slide_index">
                    <Optional v-for="n of [0, 1, 2, 3]" :key="n" v-model="conveyor.options[n].selected" :title="conveyor.options[n].name" @change="get_price('s')">
                        <div class="info_style_1">
                            <div class="info_style_1_content">
                                <div class="info_style_1_title">{{ conveyor.options[n].name }}</div>
                                <hr />
                                <img class="info_style_1_image" :src="conveyor.options[n].image" :alt="conveyor.options[n].name" />
                                <div class="info_style_1_description">{{ conveyor.options[n].description }}</div>
                            </div>
                        </div>
                    </Optional>
                </Slide>
                
                <Slide index="3" title="Электрическая оснастка" :cur_index="slide_index">
                    <Optional v-for="n of [7, 13, 8, 9, 10, 11, 12]" :key="n" v-model="conveyor.options[n].selected" :title="conveyor.options[n].name" @change="select_conveyor_option(n)">
                        <div class="info_style_1">
                            <div class="info_style_1_content">
                                <div class="info_style_1_title">{{ conveyor.options[n].name }}</div>
                                <hr />
                                <img class="info_style_1_image" :src="conveyor.options[n].image" :alt="conveyor.options[n].name" />
                                <div class="info_style_1_description">{{ conveyor.options[n].description }}</div>
                            </div>
                        </div>
                    </Optional>
                </Slide>

                <!-- итоговое окно для мобильного варианта -->
                <Slide index="4" title="Итог" :cur_index="slide_index">
                    <div class="summary">
                        <!-- Чертежи -->
                        <Paragraph title="Чертежи">
                            <PictureWrapper>
                                <!-- динамический чертеж -->
                                <Picture :url="draw_url" title="Чертеж" width="40%" @click="get_fancy_box(dynamic_draw_url)"></Picture>
                                <!-- внешний вид -->
                                <Picture :url="view_url" title="Внешний вид" width="40%"></Picture>
                            </PictureWrapper>
                        </Paragraph>

                        <Paragraph title="Параметры">
                            <Parameter title="Ширина ленты, мм" :value="conveyor.band_width || 'не выбран'"></Parameter>
                            <Parameter title="Тип ленты" :value="conveyor.options[conveyor.band_type].name || 'не выбран'"></Parameter>
                            <Parameter title="Длина конвейера, м" :value="conveyor.length || 'не выбран'"></Parameter>                            
                        </Paragraph>

                        <!-- итоговая часть -->
                        <div class="summary_end">
                            <Paragraph title="Получить предложение">
                                <Submit title="Получить" url="https://tulmash.ru/api_new/index.php" :data="submit"></Submit>
                            </Paragraph>
                        </div>
                    </div>
                </Slide>
            </Slider>
            <!-- дубль цены для мобильного варианта -->
            <Paragraph title="Стоимость" class="mobile_only">
                <div class="field price">{{ price_formatted }}</div>
            </Paragraph>
        </WidgetPart>
        <WidgetPart>
            <div class="summary">
                <!-- Чертежи -->
                <Paragraph title="Чертежи">
                    <PictureWrapper>
                        <!-- динамический чертеж -->
                        <Picture :url="draw_url" title="Чертеж" width="40%" @click="get_fancy_box(dynamic_draw_url)"></Picture>
                        <!-- внешний вид -->
                        <Picture :url="view_url" title="Внешний вид" width="40%"></Picture>
                    </PictureWrapper>
                </Paragraph>

                <Paragraph title="Параметры" v-if="conveyor.options">
                    <Parameter title="Ширина ленты, мм" :value="conveyor.band_width || 'не выбран'"></Parameter>
                    <Parameter title="Тип ленты" :value="conveyor.options[conveyor.band_type].name || 'не выбран'"></Parameter>
                    <Parameter title="Длина конвейера, м" :value="conveyor.length || 'не выбран'"></Parameter>                    
                </Paragraph>

                <!-- итоговая часть -->
                <div class="summary_end">
                    <Paragraph title="Стоимость">
                        <div class="field price ellipsis">{{ price_formatted }}</div>
                    </Paragraph>

                    <Paragraph title="Получить предложение">
                        <Submit title="Получить" url="https://tulmash.ru/api_new/index.php" :data="submit"></Submit>
                    </Paragraph>
                </div>
            </div>
        </WidgetPart>
    </Widget>
</template>

<script>
import axios from "axios";
import * as widget_components from "../../widget_components";

export default {
    name: "App",
    components: widget_components,
    data() {
        return {
            widget_style: undefined,
            slide_index: 1,
            
            // параметры конвейера
            conveyor: {
                price: 0,
                length: undefined,
                band_type: 4,
                band_width: 500,
                length_min: undefined,
                length_max: undefined,
                band_widths: undefined,
                options: undefined,
            },
        };
    },

    computed: {
        length2() {
            let tmp = this.conveyor.length;
            if (!tmp) return 0;

            tmp = tmp.replaceAll(",", ".");
            tmp = tmp.replaceAll("..", ".");
            tmp = tmp.replaceAll("..", ".");
            tmp = tmp.replaceAll("..", ".");
            tmp = tmp.replaceAll("..", ".");
            tmp = tmp * 1;
            return tmp;
        },

        length3() {
            return this.length2 * 1000;
        },

        length_error() {
            if (this.conveyor.length === undefined || this.conveyor.length == "") return false;
            if (!this.conveyor.length) return true;
            if (this.conveyor.length * 1 < this.conveyor.length_min) return true;
            if (this.conveyor.length * 1 > this.conveyor.length_max) return true;
            return false;
        },

        length_error_message() {
            if (!this.conveyor.length) return "";
            if (this.conveyor.length * 1 < this.conveyor.length_min) return `Минимальная длина конвейера - ${this.conveyor.length_min} метра`;
            if (this.conveyor.length * 1 > this.conveyor.length_max) return `Максимальная длина конвейера - ${this.conveyor.length_max} метров`;
            return "";
        },

        price_formatted() {
            if (!this.conveyor.band_width) return "-";
            if (!this.length2) return "-";            
            if (this.conveyor.price == "-") return "-";

            let formatter = new Intl.NumberFormat("ru-RU", {
                style: "currency",
                currency: "RUB",
            });
            return "от " + formatter.format(this.conveyor.price);
        },

        // путь к чертежу с динамическими данными
        draw_url() {
            if (this.length3 == 0 || this.conveyor.band_width == 0) {
                return `https://tulmash.ru/api_new/?mode=get_conveyor_draw&l=3000&b=500&tm=${new Date()}`;
            } else {
                return `https://tulmash.ru/api_new/?mode=get_conveyor_draw&l=${this.length3}&b=${this.conveyor.band_width}&tm=${new Date()}`;
            }
        },

        // путь к общему виду
        view_url() {

            if(this.length2>12.037) return "https://tulmash.ru/api_new/app/calculators/img/conv_view_2.png"
            if(!this.length2 || this.length2<=12.037) return "https://tulmash.ru/api_new/app/calculators/img/conv_view_1.png"
            return ""
        },

        // датнные для получения КП
        submit() {
            if (!this.data_is_ready_to_send()) return undefined;

            return {
                mode: "get_conveyor_kp",
                l: this.conveyor.length,
                w: this.conveyor.band_width,
                options: this.options,
                price: this.conveyor.price
            };
        },
    },

    mounted() {
        axios.get("https://tulmash.ru/api_new/?mode=get_feeder_data").then((response) => {
            
            this.conveyor.length_min = response.data.conveyor.length_min;
            this.conveyor.length_max = response.data.conveyor.length_max;
            this.conveyor.band_widths = response.data.conveyor.band_widths;
            this.conveyor.options = response.data.conveyor.options;            

            this.conveyor.options[0].selected = true // опорные сойки по-умолчанию выбраны
            this.conveyor.options[7].selected = true // силовой щит по-умолчанию выбран
            this.conveyor.options[13].selected = false // щит c частотником по-умолчанию не выбран
        });
    },

    methods: {
        set_style(e) {
            this.widget_style = e.style;
        },

        select_conveyor_option(index) {
            // обработка взаимоисключающих опций конфейера
            if (index == 13 && this.conveyor.options[index].selected == true) this.conveyor.options[7].selected = false;
            if (index == 7 && this.conveyor.options[index].selected == true) this.conveyor.options[13].selected = false;
            this.get_price("s");
        },

        normalize_data() {
            // костыль для типа ленты - надо будет убрать
            if (!this.conveyor.options) return false;
            this.conveyor.options[this.conveyor.band_type].selected = true;
            if (this.conveyor.options[this.conveyor.band_type].selected) {
                switch (this.conveyor.band_type) {
                    case 4:
                        this.conveyor.options[5].selected = false;
                        this.conveyor.options[6].selected = false;
                        break;
                    case 5:
                        this.conveyor.options[4].selected = false;
                        this.conveyor.options[6].selected = false;
                        break;
                    case 6:
                        this.conveyor.options[4].selected = false;
                        this.conveyor.options[5].selected = false;
                        break;
                }
            }

            // если не выбрана ни одна лента - выбираем первую (самую простую)
            if (this.conveyor.options[4].selected === false && this.conveyor.options[5].selected === false && this.conveyor.options[6].selected === false) {
                this.conveyor.options[4].selected = true;
            }

            return true;
        },

        data_is_ready_to_send() {
            if (!this.normalize_data()) return false;
            if (!this.conveyor.band_width) return false;
            if (!this.length2) return false;
            if (this.length_error) return false;
            return true;
        },

        get_price: function (par = null) {
            // проверяем корректность данных перед отправкой
            if (!this.data_is_ready_to_send()) return (this.conveyor.price = "-");

            let params = {
                mode: "get_conveyor_price",
                w: this.conveyor.band_width * 1,
                l: this.length2,
                options: this.conveyor.options,
                tm: new Date(),
            };

            let formData = new FormData();
            for (let key in params) {
                let param = params[key];
                if (typeof param == "object") {
                    param = JSON.stringify(param);
                }
                formData.append(key, param);
            }

            axios
                .post("https://tulmash.ru/api_new/index.php", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {                    
                    if (par !== null) {
                        this.conveyor.price = response.data.price;
                        this.options = response.data.options;                        
                    }                    
                });
        },
    },
};
</script>

<style>
.widget .ellipsis {
    overflow: hidden;
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.widget .field {
    color: #666;
    color: black;
    padding: 6px;
    font-size: 1rem;
    display: block;
    background: #fafafa;
    transition: all 0.2s linear;
    border: 1px solid lightgray;
    flex-grow: 1;
    box-sizing: border-box;
    cursor: pointer;
    outline: none;
    display: block;
}

.widget .field.short {
    margin-right: 23px;
}

.widget .required {
    border-color: red;
    border-style: dashed;
}

.widget .disabled {
    color: grey;
}

.widget hr {
    border: 0.5px solid #fc5a0a;
    width: 80%;
    margin: 3px auto;
    padding: 0px;
}

.widget .noselect {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

</style>

<style scoped>
.summary {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}

.summary_end {
    margin-top: auto;
    margin-bottom: 5px;
    display: flex;
    flex-direction: column;
}

.lable {
    margin-top: 5px;
    color: gray;
    padding: 5px;
    padding-bottom: 0px;
    width: 95%;
    text-align: center;
}

.field_container {
    display: flex;
    justify-content: flex-start;
}

.price {
    font-weight: bold;
    text-align: center;
    background: none;

    margin: 0 !important;
    width: auto;

    box-shadow: none;
    border-radius: 0px;
    color: black;
}

.error {
    color: red;
}

.hidden {
    display: none;
}

.image_container {
    display: flex;
    flex-direction: row;
    padding: 10px;
}

.info_style_1 {
    /* width: 300px; */
    width: auto;
}

.info_style_1_content {
    border-radius: 5px;
    margin: 5px;
    overflow: hidden;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
}

.info_style_1_content > * {
    margin: auto;
}

.info_style_1_content > hr {
    width: 100%;
}

.info_style_1_image {
    width: 230px;
    height: 230px;
    object-fit: contain;
    border-right: 5px;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.1);
    margin: 10px auto;
    border-radius: 10px;
}

.info_style_1_title {
    text-align: center;
    width: 230px;
    margin-bottom: 5px;
}

.info_style_1_description {
    text-align: center;
    width: 230px;
    font-style: italic;
    font-size: 10pt;
}

/* модальное окно по бункеру */
.bunker_info {
    width: 700px;
}

.bunker_info_title {
    width: 100%;
    text-align: center;
    font-weight: bold;
}

.bunker_info_row {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.bunker_info_block {
    margin: 10px;
    width: 300px;
    height: auto;
    min-height: 150px;
    border: 1px solid lightgray;
    border-radius: 5px;
    overflow: hidden;
    display: flex;
    justify-content: center;
}

.bunker_info_list {
    padding: 0px;
    margin: 5px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-left: 25px;
}

.bunker_info_list > li {
    font-size: 10pt;
    padding-bottom: 2px;
}

.bunker_image {
    margin: auto;
    width: 200px;
    height: auto;
    object-fit: contain;
}

.circle {
    list-style-type: disc !important;
}

.widget.mobile .bunker_info {
    width: 100%;
    height: auto;
    /* background: green; */
}

.widget.mobile .bunker_info > .bunker_info_row {
    flex-direction: column;
}

.widget.mobile .bunker_info > .bunker_info_row > .bunker_info_block {
    margin: 5px;
    width: auto;
    min-height: auto;
}

.widget.desktop .mobile_only{
    display: none;
}
</style>
